import { render, staticRenderFns } from "./InfiniteIcon.vue?vue&type=template&id=a35872fa&scoped=true"
import script from "./InfiniteIcon.vue?vue&type=script&lang=js"
export * from "./InfiniteIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a35872fa",
  null
  
)

export default component.exports